import { messaging } from "./firebase-config";
import { deleteToken } from "firebase/messaging";
import { getToken } from "firebase/messaging";

export const removeFCMToken = async () => {
    try {
      const currentToken = await getToken(messaging, {
        vapidKey: "BCkLspZOGz37ze9YlJ6d9gP1PplUFIast0l40pt5HYsYNz3eBL_I3sIoluXMvBnHzMfIRYiYrblfyPp6fW9Bjzc",
      });
  
      if (currentToken) {
        await deleteToken(messaging);
        console.log("FCM token deleted from client owner");
      }
    } catch (error) {
      console.error("Failed to delete FCM token:", error);
    }
  };